// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge_E_hUW","fullWidth":"Badge_fullWidth_Zeft7","dash":"Badge_dash_ZAwG1"};